import { colors } from "constants/colorsBase";
import styled from "styled-components";

export const Input = styled.input`
  color: ${colors.mainText};
  font-weight: bold;
  font-size: 1.25rem;
`;
